import React, { useState, useEffect } from "react";
// import { withTranslation } from "react-i18next";
import { BiDesktop, BiBookOpen, BiUserCheck } from "react-icons/bi";
import { LuNotebookPen } from "react-icons/lu";
// import { Row, Col } from "react-bootstrap";
import { RiWhatsappLine } from "react-icons/ri";

import FAQ from "./faq";
import { CoursDetails } from "./coursDetails/index";
import Button from "../../components/elements/button";
import LandingPage from "../home/about";
import Testimonials from "../home/testimonials";
import "./index-home.css";
import { whatsAppRedirect } from "../../hooks/common";
import Modalidades from "../modalidadeTest"
import TestimonialsCarousel from "../../components/elements/testimonials";

export function Home(props) {
  //   const { t } = props;

  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const [categories, setCategories] = useState([]);

  const categoriesObjs = [
    // {
    //     id: "f1b7543c-590e-4949-b25c-5ac0ef3f6889",
    //     title: "home_cards.simple_app.title",
    //     details: [
    //         "Click & Play",
    //         "No Download required!",
    //     ],
    //     description: "home_cards.simple_app.descriptionSubcategory",
    //     Games: simpleApp,
    // },
    // {
    //     id: "843762dc-8779-4624-9d1f-a54b3837b61f",
    //     title: "home_cards.real_timne_app.title",
    //     details: [
    //         "Click & Play",
    //         "No Download required!",
    //     ],
    //     description: "games.descriptionSubcategory",
    //     Games: realTimeApp,
    // },
    // {
    //     id: "df1a5874-042c-499b-acfd-5a74334bdf3d",
    //     title: "home_cards.advanced_projects.title",
    //     details: [
    //         "Click & Play",
    //         "No Download required!",
    //     ],
    //     description: "home_cards.advanced_projects.descriptionSubcategory",
    //     Games: advancedProjects,
    // },
    // {
    //     id: "bbbb5cd3-230e-4b20-bc8a-76274bfef7e8",
    //     title: "home_cards.intermediate_projects.title",
    //     details: [
    //         "Click & Play",
    //         "No Download required!",
    //     ],
    //     description: "home_cards.intermediate_projects.descriptionSubcategory",
    //     Games: intermediateProjects,
    // },
    // {
    //     id: "0eac3ede-9347-49af-be62-036b6ac1f77c",
    //     title: "home_cards.games.title",
    //     details: [
    //         "Click & Play",
    //         "No Download required!",
    //     ],
    //     description: "games.descriptionSubcategory",
    //     Games: games,
    // },
    // {
    //     id: "72d3bd33-9ce6-43a6-8ec1-b17b2b3c1452",
    //     title: "home_cards.single_page_app.title",
    //     details: [
    //         "Click & Play",
    //         "No Download required!",
    //     ],
    //     description: "games.descriptionSubcategory",
    //     Games: singlePageApp,
    // },
    // {
    //     id: "925f5059-89a0-4dd0-9f40-1099992ae70c",
    //     title: "home_cards.simple_gallery_app.title",
    //     details: [
    //         "Click & Play",
    //         "No Download required!",
    //     ],
    //     description: "games.descriptionSubcategory",
    //     Games: simpleGalleryApp,
    // },
  ];
  //   useEffect(() => {
  //     setCategories(
  //       categoriesObjs
  //         .map((item) => ({
  //           ...item,
  //           title: item.title,
  //         }))
  //         .sort((a, b) => a.title.localeCompare(b.title)),
  //     );
  //   }, [t]);

  // const studentTestimonials = [
//   {
//     id: "student-01",
//     name: "Nome do estudante",
//     course: "Redação ENEM",
//     quote: "Depoimento autorizado do estudante.",
//     result: "Evolução na escrita",
//     detail: "Descrição adicional, se houver.",
//     avatar: "/images/students/student-01.webp",
//     social: [
//       { label: "Instagram", url: "https://instagram.com/real-profile" }
//     ],
//     profileUrl: "https://example.com/profile",
//     color: "sage"
//   }
// ];

// <TestimonialsCarousel testimonials={studentTestimonials} speed={35} />

  //   --------------------------------------------------------------------------------------

  function Feature({ icon: Icon, text }) {
    return (
      <div className="hero-feature">
        <Icon className="hero-feature-icon" />
        <span>{text}</span>
      </div>
    );
  }

  return (
    <>
      <main>
        {/* HERO */}
        <section id="inicio" className="hero-section">
          <div className="container">
            <div className="row g-0 align-items-stretch hero-card">
              <div className="col-lg-6 hero-copy">
                <span className="eyebrow">ESCRITA PRÁTICA</span>

                <h1>
                  Transforme suas ideias
                  <br className="d-none d-xl-block" /> em uma redação mais{" "}
                  <span>clara, estruturada e convincente</span>
                </h1>

                <p className="hero-description">
                  Mentorias individuais, aulas online e correções com feedback
                  personalizado para você alcançar sua melhor versão na escrita.
                </p>

                <div className="hero-actions">
                  <Button onClick={whatsAppRedirect}>
                    <RiWhatsappLine /> QUERO MELHORAR MINHA REDAÇÃO
                  </Button>

                  <Button variant="outlined">CONHECER O MÉTODO</Button>
                  {/* <Modalidades /> */}
                </div>

                <div className="hero-features">
                  <Feature icon={BiDesktop} text="AULAS ONLINE" />
                  <Feature icon={BiBookOpen} text="CORREÇÕES COM FEEDBACK" />
                  <Feature
                    icon={BiUserCheck}
                    text="ATENDIMENTO PERSONALIZADO"
                  />
                  <Feature icon={LuNotebookPen} text="FOCO EM RESULTADOS" />
                </div>
              </div>

              <div className="col-lg-6 hero-media">
                <img
                  src="/images/professora.jpg"
                  alt="Professora Iasmyn Souza Louis"
                />
              </div>
            </div>
          </div>
        </section>

        <CoursDetails />
        <LandingPage />
        {/* <Testimonials /> */}
        <TestimonialsCarousel />
        <FAQ />
      </main>
    </>
  );
}

export default Home;